import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import globalMiddleware from "../../hocs/globalMiddleware";
import {setCurrentRoute} from "../../store/actions/globalActions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import DoctorProfile from "../../components/doctors/DoctorProfile";
import HospitalProfile from "../../components/doctors/HospitalProfile";
import NoMatch from "../NoMatch";

class DoctorAndHospitalProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numOfServices: 3,
            numOfIncCompanies: 5,
        }
    }

    setWindowRef = (ref) => {
        console.log(ref);
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
    }

    toggleShowMore = (e, num, stateVariable, collapsePropsLength) => {
        e.preventDefault();
        switch (stateVariable) {
            case "numOfServices" :
                this.setState({
                    numOfServices: this.state.numOfServices === num ? collapsePropsLength : num,
                });
                break;
            case "numOfIncCompanies" :
                this.setState({
                    numOfIncCompanies: this.state.numOfIncCompanies === num ? collapsePropsLength : num,
                });
                break;
            default:
        }
    };

    render() {
        if (this.props.match.params.is_hospital && this.props.match.params.is_hospital !== "hospital") {
            return (<NoMatch/>)
        }
        return (
            this.props.match.params.is_hospital === "hospital" ?
                <HospitalProfile setWindowRef={this.setWindowRef} language={this.props.language}
                                 numOfIncCompanies={this.state.numOfIncCompanies}
                                 numOfServices={this.state.numOfServices}
                                 toggleShowMore={(e, num, stateVariable, collapsePropsLength) => this.toggleShowMore(e, num, stateVariable, collapsePropsLength)}
                                 authUser={this.props.authUser}/>
                :
                <DoctorProfile language={this.props.language} numOfIncCompanies={this.state.numOfIncCompanies}
                               numOfServices={this.state.numOfServices}
                               toggleShowMore={(e, num, stateVariable, collapsePropsLength) => this.toggleShowMore(e, num, stateVariable, collapsePropsLength)}
                               authUser={this.props.authUser}/>
        )
    }
}

const
    mapStateToProps = (state) => {
        return {}
    };

const
    mapDispatchToProps = (dispatch) => {
        return {
            setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
        }
    };

export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(withRouter(DoctorAndHospitalProfile))));